<script setup lang="ts">
import { TooltipTrigger as TooltipTriggerPrimitive, type TooltipTriggerProps } from 'reka-ui';

defineProps<TooltipTriggerProps>();
</script>

<template>
    <TooltipTriggerPrimitive v-bind="$props" as-child>
        <slot />
    </TooltipTriggerPrimitive>
</template>
